const STORAGE_PREFIX = 'bruins09:keeper-vault:';

export function keeperVaultStorageKey(slug) {
  return `${STORAGE_PREFIX}${slug}`;
}
